import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

import "./App.css";
import Bike from "./components/New_Templates/Bike";
import Homepage from "./components/New_Templates/Home";
import Mining from "./components/New_Templates/Mining";
import SchoolBus from "./components/New_Templates/school_bus";
import ProductsOverview from "./components/New_Templates/ProductsOverview";
// import About from "./components/about/AboutUs";
import About from "./components/New_Templates/About";
import AddressPage from "./components/AddressPage/AddressPage";
import OrderDetailsPage from "./components/OrderDetailsPage/OrderDetailsPage";
import LoginPage from "./components/Login/Login";
import Contact from "./components/New_Templates/Contact";
import Hero from "./components/careers/Hero";
import RelatedBlogs from "./components/Blogs/RelatedBlogs";
import BlogDetail from "./components/Blogs/BlogDetail";
import ProductTheme2 from "./components/ProductTheme2/Landingpage2";
import Products from "./components/New_Templates/Products";
import CartPage from "./components/New_Templates/CartPage";
import SelectAddressPage from "./components/Cart/Cart";
import CartSidebar from "./components/CartSidebar/CartSidebar";
import VerifyOtp from "./components/VerifyOtp/VerifyOtp";
import ProfilePage from "./components/ProfilePage/ProfilePage";
import { CartProvider } from "./contexts/CartContext";
import OrderPlaced from "./components/New_Templates/OrderPlaced";

import OrderItemDetails from "./components/OrderItemDetails/OrderItemDetails";
import Loader from "./components/New_Templates/Loader";
import DemoSection from "./components/New_Templates/DemoSection";
import { WebsiteDataProvider } from "./components/New_Templates/WebsiteDataContext";
import BlogList from "./components/Blogs/BlogList";
import invoice from "./components/OrderItemDetails/InvoicePrintable";
// import TermsAndConditions from "./components/New_Templates/terms";
import FloatingButtons from "./components/New_Templates/FloatingButtons";
import ApiService from "./components/Services/ApiServices";

import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import AuthRedirectRoute from "./components/ProtectedRoute/AuthRedirectRoute";
import CheckoutPage from "./components/CheckoutPage/CheckoutPage";
import OfferPopup from "./components/OfferPopup/OfferPopup";
import OfferController from "./components/OfferController/OfferController";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/New_Templates/Navbar";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "react-hot-toast";
import NotFound from "./components/NotFound/Notfound";

import TermsAndConditions from "./components/LegalPoliciesPages/TermsAndConditions/TermsAndConditions";
import WarrantyPolicies from "./components/LegalPoliciesPages/WarrentyPolicies/warrentyPolicies";
import CancellationRefundPolicy from "./components/LegalPoliciesPages/Cancellationpolicies/Cancellationpolicies";
import ShippingPolicy from "./components/LegalPoliciesPages/ShippingPolicies/ShippingPolicies";
import ReplacementServicePolicy from "./components/LegalPoliciesPages/ReplacementPolicies/ReplacementPolicies";
import PrivacyPolicy from "./components/LegalPoliciesPages/PrivacyPolicies/PrivacyPolicies";
import DisclaimerPolicy from "./components/LegalPoliciesPages/Disclimer/Disclimer";
import Footer from "./components/New_Templates/Footer";
import LoginGate from "./components/independence-day/LoginGate";
import SiteAmbience from "./components/independence-day/SiteAmbience";
import WishesStrip from "./components/independence-day/WishesStrip";
import ThemeDetails from "./components/ThemeDetails/ThemeDetails";
import FAQSection from "./components/New_Templates/FaqSection/FaqSection";

const App = () => {
  const [websiteData, setWebsiteData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retryCount, setRetryCount] = useState(0);

  const userData = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchWebsiteData = async () => {
      try {
        setLoading(true);
        setError("");

        const payload = {
          companyCode: "WAY4TRACK",
          unitCode: "WAY4",
        };

        const response = await ApiService.post(
          "/website-product/getWebsiteProductDetails",
          payload,
        );

        if (response?.status && Array.isArray(response?.data)) {
          setWebsiteData(response.data);
        } else {
          setWebsiteData([]);
          setError("Invalid response received from server.");
        }
      } catch (err) {
        console.error("Website API Error:", err);

        if (!navigator.onLine) {
          setError("No internet connection.");
        } else if (err.code === "ECONNABORTED") {
          setError("Request timeout. Please try again.");
        } else if (err.response?.status >= 500) {
          setError("Server error. Please try again later.");
        } else {
          setError(
            err.response?.data?.message ||
            err.message ||
            "Something went wrong.",
          );
        }

        setWebsiteData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWebsiteData();
  }, [retryCount]);

  const handleRetry = () => {
    setRetryCount((prev) => prev + 1);
  };

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="global-error-container">
        <div className="global-error-card">
          <img
            src="/images/error-state.png"
            alt="Error"
            className="global-error-image"
          />

          <h2>Unable to Load Website</h2>

          <p>{error}</p>

          <button onClick={handleRetry} className="global-retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <HelmetProvider>
      <SiteAmbience />

      {/* Fixed to the bottom of the viewport on every route. Mounted here,
          at the root, so no ancestor transform/filter can re-anchor it away
          from the viewport. Self-gated: off the date it renders nothing. */}
      <WishesStrip />
      <WebsiteDataProvider websiteData={websiteData}>
        <AuthProvider>
          <CartProvider>
            <Router>
              <>
                {/* <OfferPopup /> */}
                <Navbar />
                {/* <OfferController /> */}

                <Routes>
                  <Route
                    path="/"
                    element={<Homepage websiteData={websiteData} />}
                  />

                  <Route
                    path="/solutions/:slug"
                    element={<ThemeDetails websiteData={websiteData} />}
                  />
                  {/* <Route path="/theme1/:slug" element={<Bike websiteData={websiteData} />} />
                    <Route path="/theme2/:slug" element={<Mining websiteData={websiteData} />} />
                    <Route path="/theme3/:slug" element={<SchoolBus websiteData={websiteData} />} /> */}

                  {/* <Route
                      path="/product/:id"
                      element={<ProductsOverview websiteData={websiteData} />}
                    /> */}

                  <Route
                    path="/products/:slug"
                    element={<ProductsOverview websiteData={websiteData} />}
                  />
                  <Route
                    path="/products"
                    element={<Products websiteData={websiteData} />}
                  />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/Careers" element={<Hero />} />
                  <Route path="/blogs" element={<BlogList />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/faqs" element={<FAQSection />} />
                  {/* <Route path="/product-theme-2" element={<ProductTheme2 />} /> */}
                  <Route
                    path="/demo"
                    element={<DemoSection websiteData={websiteData} />}
                  />

                  <Route
                    path="/termsandconditions"
                    element={<TermsAndConditions />}
                  />
                  <Route
                    path="/warranty-policy"
                    element={<WarrantyPolicies />}
                  />
                  <Route
                    path="/cancellation-policy"
                    element={<CancellationRefundPolicy />}
                  />
                  <Route path="/shipping-policy" element={<ShippingPolicy />} />
                  <Route
                    path="/replacement-policy"
                    element={<ReplacementServicePolicy />}
                  />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route
                    path="/disclaimer-policy"
                    element={<DisclaimerPolicy />}
                  />

                  <Route element={<AuthRedirectRoute />}>
                    <Route path="/login" element={<LoginGate />} />

                  </Route>
                  <Route path="/verify-otp" element={<VerifyOtp />} />

                  <Route element={<ProtectedRoute />}>
                    <Route path="/my-profile" element={<ProfilePage />} />
                    <Route path="/address-page" element={<AddressPage />} />
                    <Route
                      path="/order-details"
                      element={<OrderDetailsPage />}
                    />
                    {/* <Route path="/order-details" element={<CheckoutPage />} /> */}
                    <Route
                      path="/delivery-address"
                      element={<SelectAddressPage />}
                    />
                    {/* <Route
                        path="/orders/:orderId/items/:deviceId"
                        element={<OrderItemDetails />}
                      /> */}
                    <Route
                      path="/orders/:orderId/items/:slug"
                      element={<OrderItemDetails />}
                    />
                    <Route path="/order-placed" element={<OrderPlaced />} />
                    <Route path="/invoice" element={<invoice />} />
                    <Route path="/cart" element={<CartPage />} />
                  </Route>
                  <Route path="*" element={<NotFound to="/" replace />} />
                </Routes>
                <FloatingButtons />

                <Footer />
              </>
            </Router>
          </CartProvider>

          <Toaster position="top-center" reverseOrder={false} />
        </AuthProvider>
      </WebsiteDataProvider>
    </HelmetProvider>
  );
};

export default App;
